module.exports = __webpack_public_path__ + "static/media/pangolier.6d37984b.png";